import Service from "./Service";
const menu = "account/";

export default {
    clearSession() {
        const keepKeys = [
            "recordateFilters",
            "processInitial",
            "notFireWorks",
            "animate5Years",
            "filterDoll",
            "managementReportTheme",
            "vacationControlTheme",
            "workerHistoryTheme",
            "currentExternalIndex",
        ];
        const preserved = {};
        keepKeys.forEach((key) => {
            const value = localStorage.getItem(key);
            if (value !== null) preserved[key] = value;
        });
        localStorage.clear();
        Object.keys(preserved).forEach((key) => {
            localStorage.setItem(key, preserved[key]);
        });
    },

    isTokenExpired() {
        const token = localStorage.getItem("token");
        if (!token) return true;
        try {
            const parts = token.split(".");
            if (parts.length !== 3) return true;
            const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
            if (payload && payload.exp) {
                // Margen de 30 segundos
                return Date.now() >= (payload.exp - 30) * 1000;
            }
            return false;
        } catch (e) {
            return false;
        }
    },

    login(UsrName, UsrPassword, captchaToken) {
        this.clearSession();

        return Service.post(menu + "login", {
            UsrName: UsrName,
            UsrPassword: UsrPassword,
        }, {
            headers: {
                "X-Recaptcha-Token": captchaToken
            }
        });
    },
    logout() {
        return Service.post(menu + "logout", {
            UsrName: UsrName,
            UsrPassword: UsrPassword,
        });
    },
    initialize(UsrID, token) {
        return Service.get(menu + "ApplicationUserInitialize", {
            params: { usrID: UsrID, showMobile:false },
        });
    },
    userOption(UsrID, optCode) {
        return Service.get(menu + "ApplicationUserOptionAllow", {
            params: { optCode: optCode, UsrID: UsrID, requestID: UsrID },
        });
    },
    changePassword(password, usr) {
        usr.UsrPassword = password;
        return Service.post(menu + "ApplicationChangePassword", usr, {
            params: { requestID: usr.UsrID },
        });
    },
    refreshToken(UsrID) {
        return Service.post(
            menu + "RefreshToken", {}, {
                params: {
                    requestID: UsrID,
                },
            }
        );
    },
};